import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GuestState {
    firstName?: string;
    lastName?: string;
    identity?: string;
}

export const initialState: GuestState = {};

const guestSlice = createSlice({
    name: 'guest',
    initialState,
    reducers: {
        setGuestContactInformation(
            state,
            action: PayloadAction<{ firstName?: string; lastName?: string; identity?: string }>
        ) {
            // Merge — only overwrite fields explicitly provided, so callers that capture
            // only e.g. an email post-payment don't wipe out a name set earlier.
            if (action.payload.firstName !== undefined) {
                state.firstName = action.payload.firstName;
            }
            if (action.payload.lastName !== undefined) {
                state.lastName = action.payload.lastName;
            }
            if (action.payload.identity !== undefined) {
                state.identity = action.payload.identity;
            }
        },
        resetGuestState() {
            return initialState;
        }
    }
});

export const { setGuestContactInformation, resetGuestState } = guestSlice.actions;
export default guestSlice.reducer;
